import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { useCaseListQuerySchema } from "@kansai-ai-hub/schema";

import { EnterpriseDashboardPage } from "@/features/enterprise/dashboard-page";
import { enterpriseDashboardQueryOptions } from "@/features/enterprise/queries";
import { casesListQueryOptions, toCaseListFilters } from "@/features/cases/queries";

const DASHBOARD_CASES_PAGE_SIZE = 9;

const dashboardSearchSchema = useCaseListQuerySchema
  .extend({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(100).default(DASHBOARD_CASES_PAGE_SIZE),
    view: z.enum(["grid", "table"]).default("grid"),
  });

export const Route = createFileRoute("/_authenticated/enterprise/")({
  validateSearch: dashboardSearchSchema,
  // view はサーバーへ送らない UI パラメータなので deps（= queryKey）から除外する
  loaderDeps: ({ search }) => toCaseListFilters(search),
  // ロールガードは親 layout (`enterprise/route.tsx`) が ENTERPRISE 限定。
  loader: async ({ context, deps }) => {
    await Promise.all([
      context.queryClient.ensureQueryData(enterpriseDashboardQueryOptions()),
      context.queryClient.ensureQueryData(casesListQueryOptions(deps)),
    ]);
  },
  component: EnterpriseDashboardPage,
});
